import { useAppSelector } from 'store/configureStore'
import { WorkingStepType } from 'services/APIs/InternalAPI/internal-api.contracts'
import { projectSelectors } from '../store/selectors/projectSelectors'

export const useNotAllowedWorkingStep = (
  bomItemId: string,
  workingStepType: WorkingStepType
) => {
  const notAllowedWorkingSteps = useAppSelector(
    projectSelectors.notAllowedWorkingStepsSelector(bomItemId)
  )

  const workingStepNotAllowed =
    notAllowedWorkingSteps?.includes(workingStepType)

  return {
    workingStepNotAllowed,
    anyNotAllowedWorkingStep: notAllowedWorkingSteps?.length > 0,
  }
}
